<div class="container-fluid">

    <div class="filters">
        <app-data-filters #dataFilters [opened]="true" [fullWidth]="true"
                          [disableSearch]="(isLoading | async) || !searchValidity.isValid"
                          [titleKey]="'truck-journeys.list.filters'"
                          [helper]="!searchValidity.isValid"
                          [helperKey]="searchValidity.messageKey"
                          [helperColor]="searchValidity.color"
                          [helperSide]="HelperPosition.RIGHT">
            <app-data-filter-group [useAvailableWidth]="true">
                <app-data-filter-input [labelKey]="'truck-journeys.list.filter.vehicle'"
                                       [(model)]="filters.vehicle">
                </app-data-filter-input>
                <app-data-filter-date [labelKey]="'truck-journeys.list.filter.planned-departure-date-between'"
                                      [(model)]="filters.plannedDepartureFrom"
                                      (modelChange)="checkSearchValidity('plannedDepartureFrom')"
                                      [maxDate]="filters.plannedDepartureTo"
                                      [required]="true">
                </app-data-filter-date>
                <app-data-filter-date [labelKey]="'truck-journeys.list.filter.planned-departure-date-and'"
                                      [(model)]="filters.plannedDepartureTo"
                                      (modelChange)="checkSearchValidity('plannedDepartureTo')"
                                      [minDate]="filters.plannedDepartureFrom"
                                      [required]="true">
                </app-data-filter-date>
                <app-data-filter-input [labelKey]="'truck-journeys.list.filter.load'"
                                       [(model)]="filters.loadNumber">
                </app-data-filter-input>
            </app-data-filter-group>
            <app-data-filter-group [useAvailableWidth]="true">
                <app-data-filter-multi-string-input [labelKey]="'truck-journeys.list.filter.loading-locations'"
                                                    [placeholderKey]="'truck-journeys.list.filter.loading-locations-placeholder'"
                                                    [(model)]="filters.pickLocationGlids">
                </app-data-filter-multi-string-input>
                <app-data-filter-multi-string-input [labelKey]="'truck-journeys.list.filter.unloading-locations'"
                                                    [placeholderKey]="'truck-journeys.list.filter.unloading-locations-placeholder'"
                                                    [(model)]="filters.dropLocationGlids">
                </app-data-filter-multi-string-input>
            </app-data-filter-group>
        </app-data-filters>
    </div>

    <div *ngFor="let truckJourneyDayGroupedList of truckJourneysPerDayGroups | keyvalue" class="boxList">
        <div class="box-title">
            <span [i18n]="'truck-journeys.list.planned-departure-date'"></span>
            <span> - {{ truckJourneyDayGroupedList.key }}</span>
        </div>
        <section class="summary-panel"
                 *ngFor="let truckJourneyList of truckJourneyDayGroupedList.value | keyvalue">
            <div class="line-content">
                <div class="truckJourneyLine">
                    <div class="truckJourneyLine-item">
                        <span [i18n]="'truck-journeys.list.vehicle'" class="font-bold"></span>
                        <span>: {{ truckJourneyList.key }}</span>
                    </div>
                    <div class="truckJourneyLine-item">
                        <span [i18n]="'truck-journeys.list.truck-journeys'" class="font-bold"></span>
                        <span>: {{ truckJourneyList.value.truckJourneys.length }}</span>
                    </div>
                    <div *ngIf="truckJourneyList.value.status !== GroupStatus.EDITED"
                         class="truckJourneyLine-actions">
                        <i (click)="startReorderTruckJourneyGroup(truckJourneyList.value)" class="fa fa-pen"></i>
                        <i (click)="openOrCloseTruckJourneyGroup(truckJourneyList.value)"
                           class="fa"
                           [ngClass]="{ 'fa-angle-down': truckJourneyList.value.status === GroupStatus.CLOSED,
                           'fa-angle-up': truckJourneyList.value.status === GroupStatus.OPENED }"></i>
                    </div>
                </div>
                <ng-container *ngIf="truckJourneyList.value.status === GroupStatus.OPENED">
                    <ng-container *ngFor="let truckJourney of truckJourneyList.value.truckJourneys">
                        <app-truck-journey-info [truckJourney]="truckJourney"
                                                [readOnly]="false"
                                                (onEditClick)="editTruckjourney(truckJourney.id, $event)">
                        </app-truck-journey-info>
                    </ng-container>
                </ng-container>
                <div *ngIf="truckJourneyList.value.status === GroupStatus.EDITED"
                     [ngClass]="{ 'hidden': !truckJourneyList.value.status }"
                     class="truckJourney-info-container">
                    <div *ngFor="let truckJourney of truckJourneyOrdering; let index=index"
                         class="truckJourney-info">
                        <div class="truckJourney-info-side">
                            <i [class._active]="index>0"
                               (click)="index>0 ? moveTruckJourneyToNewPosition(index, index-1) : noop()"
                               class="fas fa-lg fa-angle-up"></i>
                            <div class="font-bold">{{ index + 1 }}</div>
                            <i [class._active]="index<truckJourneyList.value.truckJourneys.length-1"
                               (click)="index<truckJourneyList.value.truckJourneys.length-1 ? moveTruckJourneyToNewPosition(index, index+1) : noop()"
                               class="fas fa-lg fa-angle-down"></i>
                        </div>
                        <app-truck-journey-info [truckJourney]="truckJourney"
                                                [readOnly]="true">
                        </app-truck-journey-info>
                    </div>
                    <div class="truckJourney-info-actions">
                        <button (click)="cancelEdition(truckJourneyList.value)" type="button" class="btn">
                            <span [i18n]="'truck-journeys.detail.button.cancel'"></span>
                        </button>
                        <button (click)="confirmEdition(truckJourneyList.value)" type="button" class="btn _success">
                            <span [i18n]="'truck-journeys.detail.button.confirm'"></span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div class="no-result" *ngIf="noResult">
        <i class="fa fa-route"></i>
        <div class="message" [i18n]="'truck-journeys.list.no-result'"></div>
    </div>
</div>

<div class="bottom-buttons">
    <button (click)="assignLoads()" class="btn button-gray">
        <span [i18n]="'truck-journeys.list.assign-loads'"></span>
    </button>
    <button (click)="createTruckjourney()" class="btn button-blue">
        <span [i18n]="'truck-journeys.list.add-truck-journey'"></span>
    </button>
</div>
